import {NonEmptyArray} from '@shared/lib/utils/type_utils';

interface LanguageMetadata {
  name: string;
  code: string;
  locale: string;
}

// First language will be the default language
export const SUPPORTED_LANGUAGES = [
  {name: 'french', code: 'fr', locale: 'fr-FR'},
  {name: 'english', code: 'en', locale: 'en-GB'},
  {name: 'spanish', code: 'es', locale: 'es-ES'},
  {name: 'german', code: 'de', locale: 'de-DE'},
] as const satisfies NonEmptyArray<LanguageMetadata>;

export type SupportedLanguage = (typeof SUPPORTED_LANGUAGES)[number]['name'];

const byName = Object.fromEntries(SUPPORTED_LANGUAGES.map(l => [l.name, l] as const));
const byCode = Object.fromEntries(SUPPORTED_LANGUAGES.map(l => [l.code, l] as const));

export function parseSupportedLanguage(lang: string): SupportedLanguage {
  if (!byName[lang]) {
    throw new Error(`Invalid SupportedLanguage: ${lang}`);
  }
  return lang as SupportedLanguage;
}

export const getLanguageByCode = (code: string | undefined): SupportedLanguage | undefined => {
  return code ? byCode[code]?.name : undefined;
};

export const getLanguageMetadata = (code: string | undefined): LanguageMetadata | undefined => {
  return code ? byCode[code] : undefined;
};
